<template>
  <div class="flex">
    <div class="carousel__arrow" @click="onPrevious">
      <i class="el-icon-arrow-left" style="color: #000"></i>
    </div>
    <div class="carousel__arrow" style="margin-left: 8px" @click="onNextPage">
      <i class="el-icon-arrow-right" style="color: #000"></i>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    total: Number,
    pageSize: {
      type: Number,
      default: 10,
    },
    page: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    onChangePage(page) {
      if (page < 1) return;
      this.$emit("changePage", page);
    },
    onNextPage() {
      let page = this.page;
      let maxPage = Math.ceil(this.total / this.pageSize);
      if (this.page == maxPage) return;
      page += 1;

      this.onChangePage(page);
    },
    onPrevious() {
      if (this.page == 1) return;
      let page = this.page;
      page -= 1;
      this.onChangePage(page);
    },
  },
};
</script>
<style lang="less" scoped>
.carousel__arrow {
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  height: 36px;
  width: 36px;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 50%;
  background-color: #abd1e7;
  color: #fff;
  text-align: center;
  font-size: 12px;

  line-height: 36px;
}
.carousel__arrow:hover {
  opacity: 0.5;
}

.carousel__arrow i {
  cursor: pointer;
}
</style>
